import React, { useCallback } from 'react';
import FilterIcon from '@atlaskit/icon/core/migration/filter';
import type { Command } from '@atlassian/jira-command-palette/src/common/types/commands/index.tsx';
import { useTransformNavigationCommands } from '../../../utils/transform-navigation-commands/index.tsx';
import type { FilterCommandProps } from './types.tsx';

export const useGetFilterCommand = () => {
	const { transformNavigationCommand } = useTransformNavigationCommands();

	const getFilterCommand = useCallback(
		({ filter, section, analytics, ...rest }: FilterCommandProps): Command => {
			const { id, url, name } = filter;

			return transformNavigationCommand(
				{
					id: `filter-${id}`,
					section,
					name,
					components: {
						LeftIcon: () => <FilterIcon label="" color="currentColor" />,
					},
					analytics: {
						action: 'filterViewed',
						filterId: id,
						metadata: {
							contentId: id,
							containerId: 'UNAVAILABLE',
							contentType: 'filter',
						},
						...analytics,
					},
					...rest,
				},
				{ path: url },
			);
		},
		[transformNavigationCommand],
	);

	return { getFilterCommand };
};
